module.exports = __webpack_public_path__ + "img/bg.dd9792e6.png";